import type { ReactNode } from "react"

export default function GiftCard({ id, name, children }: { id: number; name: string; children: ReactNode }) {
  return (
    <article id={`gift-${id}`} tabIndex={-1} aria-label={name} className="gift-card grid grid-cols-[96px_minmax(0,1fr)] gap-3 p-4 bg-white rounded-xl shadow-sm focus-visible:outline-2 focus-visible:outline-blue-600">
      {children}
    </article>
  )
}
